import { render } from "./StafetOpretHoldStepTwo.vue?vue&type=template&id=feb3be92"
import script from "./StafetOpretHoldStepTwo.vue?vue&type=script&lang=js"
export * from "./StafetOpretHoldStepTwo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__